<template>
  <div class="form-plain-step-questions">
    <template v-for="question in questions">
      <validation-observer
        :key="`${stepId}_${question.questionId}`"
        v-slot="questionObserver"
        slim
      >
        <validation-observer-event-emitter
          :id="`question-${stepId}-${question.questionId}`"
          :observer="questionObserver"
          class="question-wrapper"
          @update="onQuestionObserverUpdate($event, question.questionId)"
        >
          <component
            :is="getQuestionComponent(question)"
            :ref="question.questionId || question.questionComponent"
            :key="question.questionId || question.questionComponent"
            :form-data="payload"
            :form-metadata="formMetadata"
            :form-metadata-paths="formMetadataPaths"
            :form-observer="stepFormObserver"
            :is-continue-triggered="isContinueTriggered"
            :product-name="formMetadata.productName"
            :product-title="formMetadata.productTitle"
            :question-component="question.questionComponent"
            :question-id="question.questionId"
            :session-data="sessionData"
            :step-data="payload"
            :step-id="stepId"
            :step-shared-data="stepSharedData"
            v-bind="question.params || {}"
            @edit-process="$emit('edit-process', $event)"
            @input="$emit('data', {
              fields: $event,
              stepId,
            })"
            @multiform-questions-details="$emit('multiform-questions-details', $event)"
            @render-after="$emit('render-after', $event)"
            @reset-continue-trigger="$emit('reset-continue-trigger', $event)"
            @set-step-shared-data="setStepSharedData"
            @toast="showToast($event)"
          />
        </validation-observer-event-emitter>
      </validation-observer>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'form-plain-step-questions',
  inject: [
    'formMetadata',
    'formMetadataPaths',
  ],
  props: {
    formObserver: {
      type: Object,
      required: true,
    },
    validated: {
      type: Boolean,
      required: true,
    },
    sessionData: {
      type: Object,
      required: true,
    },
    questions: {
      type: Array,
      required: true,
    },
    payload: {
      type: Object,
      required: true,
    },
    stepId: {
      type: String,
      required: true,
    },
    isContinueTriggered: {
      type: Boolean,
      required: true,
    },
  },
  data () {
    return {
      stepSharedData: {},
    };
  },
  computed: {
    stepFormObserver () {
      return {
        ...this.formObserver,
        validated: this.validated,
      };
    },
  },
  methods: {
    ...mapActions(['showToast']),
    getQuestionComponent ({ questionId, questionComponent }) {
      return `question-${questionComponent || questionId}`;
    },
    onQuestionObserverUpdate (observer, questionId) {
      this.$emit('question-observer', {
        questionId,
        observer,
      });
    },
    setStepSharedData (data) {
      this.stepSharedData = { ...this.stepSharedData, ...data };
    },
  },
};
</script>

<style lang="scss" scoped>
.question-wrapper + .question-wrapper { margin-top: -1px; }
</style>
